export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.hook('app:error', (error) => {
		console.error('Detailed error:', error)
		// You could log this to a file or external service
	})
})